<mat-tab-group (selectedIndexChange)="onTabChange($event)" [(selectedIndex)]="currentTabIndex">
  <mat-tab label="{{ organizationsTab }}"></mat-tab>
  <mat-tab label="{{ quotasTab }}"></mat-tab>
</mat-tab-group>
